var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',[_vm._v("Row number")]),_c('row-selector',{attrs:{"config":_vm.config},model:{value:(_vm.model.rules.rows),callback:function ($$v) {_vm.$set(_vm.model.rules, "rows", $$v)},expression:"model.rules.rows"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }